import { IFilter } from "../../store/browse/models";

export default (filters: IFilter[], name: string) => {
    let i = filters.findIndex(filter => filter.name === name);
    if (i !== -1) {
        return filters[i].value;
    } else {
        return undefined;
    }
};
